/* eslint-disable @typescript-eslint/no-explicit-any */
// eslint-disable-next-line no-underscore-dangle
let _hasOwnProperty = Object.prototype.hasOwnProperty;

function hasOwnProperty(
  object: {
    [key: string]: any;
  },
  propertyName: string,
): boolean {
  return _hasOwnProperty.call(object, propertyName);
}

export default hasOwnProperty;
